export default __webpack_public_path__ + "static/media/42t.cb12eef1.jpg";